import { useState } from "react";
import { Reply, Loader2, Send, CheckCircle2, X } from "lucide-react";
import { api, fmtError } from "../lib/api";
import { toast } from "sonner";

export const NotifReply = ({ notif }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(!!notif.replied_at);

  if (!notif.reply_to) return null;

  if (sent) {
    return (
      <p data-testid={`notif-replied-${notif.notif_id}`}
         className="mt-2 flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.15em] text-emerald-400">
        <CheckCircle2 className="h-3.5 w-3.5" /> Répondu par email
      </p>
    );
  }

  const send = async () => {
    if (msg.trim().length < 5) {
      toast.error("Message trop court (5 caractères minimum)");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/admin/notifications/${notif.notif_id}/reply`, { message: msg });
      toast.success(`Réponse envoyée à ${notif.reply_to}`);
      setSent(true);
    } catch (e) {
      toast.error(fmtError(e));
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        data-testid={`notif-reply-open-${notif.notif_id}`}
        className="mt-2 flex items-center gap-1.5 border border-amber-500/40 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.15em] text-amber-400 transition-colors hover:bg-amber-500 hover:text-black"
      >
        <Reply className="h-3 w-3" /> Répondre
      </button>
    );
  }

  return (
    <div className="mt-2 space-y-2" data-testid={`notif-reply-box-${notif.notif_id}`}>
      <p className="text-[10px] uppercase tracking-[0.15em] text-zinc-500">
        À : {notif.from_name ? `${notif.from_name} · ` : ""}{notif.reply_to}
      </p>
      <textarea
        value={msg}
        onChange={(e) => setMsg(e.target.value)}
        rows={3}
        autoFocus
        data-testid={`notif-reply-input-${notif.notif_id}`}
        placeholder="Votre réponse (envoyée par email depuis contact@laconsoledesartistes.fr)…"
        className="w-full border border-white/15 bg-transparent px-3 py-2 text-sm outline-none transition-colors focus:border-amber-500"
      />
      <div className="flex gap-2">
        <button
          onClick={send}
          disabled={busy}
          data-testid={`notif-reply-send-${notif.notif_id}`}
          className="flex items-center gap-1.5 bg-amber-500 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.15em] text-black transition-colors hover:bg-amber-400 disabled:opacity-50"
        >
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3" />}
          Envoyer
        </button>
        <button
          onClick={() => { setOpen(false); setMsg(""); }}
          data-testid={`notif-reply-cancel-${notif.notif_id}`}
          className="flex items-center gap-1.5 border border-white/15 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-400 transition-colors hover:border-white/40"
        >
          <X className="h-3 w-3" /> Annuler
        </button>
      </div>
    </div>
  );
};
